<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2 v-if="this.id">Edit</h2> 
                <h2 v-else>Create</h2>
                <h4>Visit</h4>
            </div>
        </div> 
        <div class="row mt-4">
            <form novalidate="novalidate" @submit.prevent="submit"  class="col col-md-12 border-top border-bottom py-4"> 
                <!--  needs-validation -->
                <div class="form-group row">
                    <div class="col-md-6">
                        <h4 class="mb-4">Details</h4>
                        <div class="form-group row">
                            <input type="hidden" id="force" required="required" class="form-control"
                                :value="this.force_id"
                                :disabled="this.loading" >

                            <div class="col-md-2">
                                <label for="visitDate" class="font-weight-bold">Date</label>
                            </div>
                            <div class="col-md-8">
                                <flat-pickr 
                                    class="form-control " :class="{'is-invalid':visitDateHasErrors}" 
                                    v-model="visit_date"
                                    :config="dateConfig">
                                </flat-pickr>
                                <form-error name="visit_date" :errors="errors"></form-error>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2">
                                <label for="visitTime" class="font-weight-bold">Time</label>
                            </div>
                            <div class="col-md-8">
                                <flat-pickr 
                                    class="form-control " :class="{'is-invalid':visitTimeHasErrors}" 
                                    v-model="visit_time"
                                    :config="timeConfig">
                                </flat-pickr>
                                <form-error name="visit_time" :errors="errors"></form-error>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2">
                                <label for="collar" class="font-weight-bold">Collar</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="collar" id="collar" required="required" class="form-control " :class="{'is-invalid': collarHasErrors}" v-model="collar">
                                <form-error name="collar" :errors="errors"></form-error>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2">
                                <label for="purpose" class="font-weight-bold">Purpose</label>
                            </div>
                            <div class="col-md-8">
                                <select class="custom-select " :class="{'is-invalid': purposeHasErrors}" id="purpose" name="purpose" required="required" v-model="purpose_id">
                                    <option value="">Select Purpose</option>
                                    <option v-for="purpose in purposes" :key="purpose.id" :value="purpose.id">
                                        {{ purpose.name }}
                                    </option>
                                </select>
                                <form-error name="purpose_id" :errors="errors"></form-error>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2">
                                <label for="otherComment" class="font-weight-bold">Other Comment</label>
                            </div>
                            <div class="col-md-8">
                                <textarea name="otherComment" id="otherComment" cols="30" rows="3" class="form-control" v-model="other_purpose_comment"></textarea>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2">
                                <label for="outcome" class="font-weight-bold">Outcome</label>
                            </div>
                            <div class="col-md-8">
                                <textarea name="outcome" id="outcome" cols="30" rows="3" class="form-control" v-model="outcome"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4 class="mb-4">Risk Rating</h4>
                        <div class="row form-group mb-0" v-for="risk in this.risks" :key="risk.id">
                            <div class="col-md-4">
                                <label for="" class="font-weight-bold">{{ risk.text }}</label>
                            </div>
                            <div class="col-md-1">
                                <input type="checkbox" name="" :id="riskAnswers[risk.id].risk_id" v-model="riskAnswers[risk.id].answer">
                            </div>
                        </div>
                    </div>
                </div> 
                <div class="form-group row">
                    <div class="col-sm-12" v-if="this.id">
                        <button type="submit" class="btn btn-primary" v-if="! this.loading">Edit</button>
                        <button type="submit"  class="btn btn-primary" disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                    <div v-else>
                        <button type="submit" class="btn btn-primary" >Create</button>
                    </div>
                </div> 
                <button class="btn btn-link" @click.prevent="back">Back</button>
            </form>
        </div>
    </div>
</template>

<script>
import store from "../../../store/index";
import RetailerVisitsService from '../../../services/RetailerVisitsService';
import FormError from "../../Util/FormError"
import RetailersService from '../../../services/RetailersService';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data: function () {
        return {
            loading: false,
            retailer: '',
            visit_date: '',
            visit_time: '',
            collar: null,
            purpose_id: '',
            other_purpose_comment: '',
            outcome: '',
            last_change_user_id: '',
            force_id: store.state.currentUser.force_id,
            riskAnswers: [],
            errors: {},
            timeConfig: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true
            },
            dateConfig: {
                dateFormat: 'd-m-Y'
            }
        }
    },

    props: {
        id: {
            default: null,
        },
        retailerId: {
            default: null,
        },
    },

    
    components: {
        FormError,
        flatPickr
    },

    mounted(){
        if (this.id) {
            this.load();
        }

        this.$store.dispatch('purposes/load');
        this.$store.dispatch('lpas/load');
        this.$store.dispatch('neighbourhoods/load');
        this.$store.dispatch('retailertypes/load');
        this.$store.dispatch('risks/load');
        this.$store.dispatch('productcategories/load');
        this.retailer = this.getRetailer();
    },

    watch: {
        id: function () {
            this.load();  
        },
    },

    methods: {

        getRetailer: function () {
            RetailersService.get(this.retailerId)
                .then(({data}) => {
                    this.retailer = data.data;
                    this.riskAnswers = this.formatRiskAnswers(data.data.risk_answers);
                });
        },

        submit: function () {
            if (this.id === null) {
                RetailerVisitsService.store(this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            } else {
                RetailerVisitsService.update(this.id, this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            }
        },

        formData: function () {
            let answers = [];
            for (const answer of this.riskAnswers) {
                if(answer != undefined) {
                    answers.push(answer);
                }
            }

            return {
                retailer_id: this.retailer.id,
                visit_date: this.visit_date,
                visit_time: this.visit_time,
                collar: this.collar,
                purpose_id: this.purpose_id,
                other_purpose_comment: this.other_purpose_comment,
                outcome: this.outcome,
                last_change_user_id: this.last_change_user_id,
                force_id: this.force_id,
                risk_answers: answers 
            };
        },

        success: function () {            
            window.flash((this.id ? 'Visit Updated' : 'Visit Created'));
            this.reset();
            this.$router.push({name: 'retailers.details', params: {id: this.retailer.id}});
        },

        failed: function (response) {
            this.errors = response.data.errors;
        },

        load: function () {
            this.loading = true;
            RetailerVisitsService.get(this.id)
                .then( ({data}) => {
                    this.retailer = data.data.retailer;
                    this.visit_date = data.data.visit_date;
                    this.visit_time = data.data.visit_time;
                    this.collar = data.data.collar;
                    this.purpose_id = data.data.purpose.id;
                    this.other_purpose_comment = data.data.other_purpose_comment;
                    this.outcome = data.data.outcome;
                    this.last_change_user_id = data.data.last_change_user_id;
                    this.force_id = data.data.force_id;
                    this.riskAnswers = this.formatRiskAnswers(data.data.risk_answers);
                    this.loading = false;
                });
        },

        reset: function () {
            this.name = this.force_id = '';
            this.errors = {};
        },

        hasError: function (key) {
            return (this.errors[key]);
        },

        formatRiskAnswers: function (riskAnswers) {
            let answers = [];

            for (const answer of riskAnswers) {
                answers[answer.risk_id] = {...answer};
            }
            return answers;
        },

        back: function () {
            this.$router.go(-1);
        },
    },

    computed: {
        visitDateHasErrors: function () { return this.hasError('visit_date') },
        visitTimeHasErrors: function () { return this.hasError('visit_time') },
        collarHasErrors: function () { return this.hasError('collar') },
        purposeHasErrors: function () { return this.hasError('purpose_id') },  
        risks: function () {
            if(this.retailer == undefined) {
                return [];
            }
            return this.$store.state.risks.data.filter(risk => risk.retailer_type_id === this.retailer.retailer_type_id);
        },
        purposes: function () {
            return this.$store.state.purposes.data;
        }
    }
}
</script>